/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2020] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var NProgress = require('nprogress');

var NavUtils = require('psa-core/util/nav');

var Scaffold = require('common/layout/Scaffold');

var GetCorrespondence = require('../../tasks/services/GetCorrespondence');

var ConSerComplaintCorrespondenceView = require('../views/ConSerComplaintCorrespondenceView');

module.exports = function(complaintId, correspondenceId) {
  NProgress.start();
  NProgress.set(0.6);
  GetCorrespondence(correspondenceId)
    .done(function(correspondence) {
      NavUtils.navigate('conser/complaint/' + complaintId + '/correspondence/' + correspondenceId);
      Scaffold.content.show(
        new ConSerComplaintCorrespondenceView({
          model: new Backbone.Model({
            complaintId: complaintId,
            correspondenceId: correspondenceId,
            correspondence: correspondence
          })
        })
      );
      NProgress.done();
    })
    .fail(function() {
      NProgress.done();
    });
};
